import {
  mockAutoSuggestOptions,
  mockOfficeResults,
  mockOfficeDetails
} from './mockData';

export const mockApi = {
  fetchAutoSuggest: (query: string, csrfToken: string | null) => {
    if (query && csrfToken) return Promise.resolve(mockAutoSuggestOptions);
  },
  fetchOfficeList: (query: string, csrfToken: string | null) => {
    if (query && csrfToken) return Promise.resolve(mockOfficeResults);
  },
  fetchOfficeDetails: (
    branchId: string,
    companyId: string,
    csrfToken: string | null
  ) => {
    if (branchId && companyId && csrfToken)
      return Promise.resolve(mockOfficeDetails);
  }
};
